var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1.5H7C7.27614 1.5 7.5 1.72386 7.5 2V7C7.5 7.27614 7.27614 7.5 7 7.5H2C1.72386 7.5 1.5 7.27614 1.5 7V2C1.5 1.72386 1.72386 1.5 2 1.5ZM0 2C0 0.89543 0.895431 0 2 0H7C8.10457 0 9 0.895431 9 2V7C9 8.10457 8.10457 9 7 9H2C0.89543 9 0 8.10457 0 7V2ZM2 12.5H7C7.27614 12.5 7.5 12.7239 7.5 13V18C7.5 18.2761 7.27614 18.5 7 18.5H2C1.72386 18.5 1.5 18.2761 1.5 18V13C1.5 12.7239 1.72386 12.5 2 12.5ZM0 13C0 11.8954 0.895431 11 2 11H7C8.10457 11 9 11.8954 9 13V18C9 19.1046 8.10457 20 7 20H2C0.89543 20 0 19.1046 0 18V13ZM18 1.5H13C12.7239 1.5 12.5 1.72386 12.5 2V7C12.5 7.27614 12.7239 7.5 13 7.5H18C18.2761 7.5 18.5 7.27614 18.5 7V2C18.5 1.72386 18.2761 1.5 18 1.5ZM13 0C11.8954 0 11 0.89543 11 2V7C11 8.10457 11.8954 9 13 9H18C19.1046 9 20 8.10457 20 7V2C20 0.895431 19.1046 0 18 0H13ZM13 12.5H18C18.2761 12.5 18.5 12.7239 18.5 13V18C18.5 18.2761 18.2761 18.5 18 18.5H13C12.7239 18.5 12.5 18.2761 12.5 18V13C12.5 12.7239 12.7239 12.5 13 12.5ZM11 13C11 11.8954 11.8954 11 13 11H18C19.1046 11 20 11.8954 20 13V18C20 19.1046 19.1046 20 18 20H13C11.8954 20 11 19.1046 11 18V13Z",
    fill: "#D8DFEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationOutline);
export default __webpack_public_path__ + "static/media/application-outline.9eaac91d212398901fe470fc192a86e7.svg";
export { ForwardRef as ReactComponent };